export default __webpack_public_path__ + "static/media/oliver_s.2cb46d0e.jpg";